import { render, staticRenderFns } from "./Expertise.vue?vue&type=template&id=269e8061&scoped=true"
import script from "./Expertise.vue?vue&type=script&lang=js"
export * from "./Expertise.vue?vue&type=script&lang=js"
import style0 from "./Expertise.vue?vue&type=style&index=0&id=269e8061&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269e8061",
  null
  
)

export default component.exports